export const showOptions = [
	{ label: '10', value: 10 },
	{ label: '25', value: 25 },
	{ label: '50', value: 50 },
	{ label: '100', value: 100 },
];

export const MIN_LIMIT_CHARACTERS_FOR_SEARCH = 3;
